interface Accumulator {
  standard?: {
    quantity: number;
    singleInstallmentAmountDue: number;
    totalAmountDue: number;
  };
  discounted?: {
    quantity: number;
    singleInstallmentAmountDue: number;
    totalAmountDue: number;
  };
}

export const reducer = (
  accumulator: Accumulator,
  currentInstallment: {
    amount_due: number;
    start_on: string;
    coupon_status: string;
  },
) => {
  if (
    currentInstallment.coupon_status === "applied" &&
    accumulator.discounted
  ) {
    accumulator.discounted.totalAmountDue += currentInstallment.amount_due;
    accumulator.discounted.singleInstallmentAmountDue =
      currentInstallment.amount_due;
    accumulator.discounted.quantity += 1;
  } else if (
    currentInstallment.coupon_status === "not_applied" &&
    accumulator.standard
  ) {
    accumulator.standard.totalAmountDue += currentInstallment.amount_due;
    accumulator.standard.singleInstallmentAmountDue =
      currentInstallment.amount_due;
    accumulator.standard.quantity += 1;
  }

  return accumulator;
};
